import * as Icons from "@nova/component-icons"
import { EventKind } from "@nova/schemas"
import { UserProfileModalTrigger } from "features/users/UserProfileModal"
import { Notification } from "../Notification"
import { AvatarIcon } from "../NotificationIcons"
import { NotificationKindProps } from "./types"

export const CommentNotification = ({
    notification,
    copy,
    actorName,
}: NotificationKindProps<EventKind.CommentCreated>) => (
    <Notification notification={notification}>
        <Notification.Icon>
            <UserProfileModalTrigger userId={notification.createdBy}>
                <AvatarIcon userId={notification.createdBy} fullName={actorName} />
            </UserProfileModalTrigger>
        </Notification.Icon>
        <Notification.Content>
            <Notification.Heading>
                <Notification.Title>{copy.title}</Notification.Title>
                {copy.subtitle && <Notification.Subtitle>{copy.subtitle}</Notification.Subtitle>}
            </Notification.Heading>
            {copy.body && <Notification.Body>{copy.body}</Notification.Body>}
            {notification.projectId && (
                <Notification.Action
                    label="View comment"
                    RightIcon={Icons.ArrowRight}
                    to={{
                        projectId: notification.projectId,
                        entityId: notification.data.mapCommentId,
                    }}
                />
            )}
        </Notification.Content>
    </Notification>
)
